import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import user1 from "../../Assets/Mithil-Patoliya.png";
import user2 from "../../Assets/Kirtan-Vaddoriya.png";
import user3 from "../../Assets/Karan-Dalwala.png";
import user4 from "../../Assets/Team-1.jpg";

import "swiper/css";
import "../../Style/ReviewSection.css";

import { myCustomTheme } from "../../Theme";

const images = {
    user1,
    user2,
    user3,
    user4,
};

const ReviewSection = () => {
    const theme = myCustomTheme;
    const reviews = useSelector((state) => state.review?.data || []);

    // ✅ OPEN ANIMATION
    useEffect(() => {
        const section = document.querySelector(".review-fluid-wrapper");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    return (
        <section
            className="review-fluid-wrapper"
            style={{
                background: theme.colors.bg_primary,
                fontFamily: theme.typography.text_font,
            }}
        >
            <div
                className="review-container-1440"
                style={{
                    maxWidth: theme.spacing.container_max,
                }}
            >
                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    loop={true}
                    speed={10000}
                    allowTouchMove={false}
                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    className="review-swiper"
                >
                    {reviews.map((item, index) => (
                        <SwiperSlide key={item.id}>
                            <div
                                className="review-card"
                                style={{
                                    background: "#242424",
                                    boxShadow: theme.shadows.theme_shadow,
                                    borderRadius: "14px",
                                    padding: "32px",
                                    minHeight: "280px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    transition: "0.3s ease",
                                    animationDelay: `${index * 0.2}s`,
                                }}
                            >
                                {/* STARS */}
                                <div
                                    className="stars"
                                    style={{
                                        color: theme.colors.high_light,
                                        marginBottom: "10px",
                                        letterSpacing: "2px",
                                    }}
                                >
                                    {"★".repeat(item.rating)}
                                </div>

                                {/* REVIEW TEXT */}
                                <p
                                    className="review-text"
                                    style={{
                                        color: theme.colors.p_text,
                                        fontStyle: "italic",
                                        lineHeight: 1.6,
                                    }}
                                >
                                    "{item.review}"
                                </p>

                                {/* USER INFO */}
                                <div
                                    className="user-info-row"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "18px",
                                    }}
                                >
                                    {/* LEFT */}
                                    <div
                                        className="profile-group"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                        }}
                                    >
                                        <img
                                            src={images[item.imageKey]}
                                            alt={item.name}
                                            className="user-img"
                                            style={{
                                                width: "52px",
                                                height: "52px",
                                                borderRadius: "50%",
                                                border: `2px solid ${theme.colors.high_light}`,
                                                objectFit: "cover",
                                            }}
                                        />

                                        <div>
                                            <h4
                                                className="user-name"
                                                style={{
                                                    margin: 0,
                                                    color: theme.colors.p_text,
                                                    fontFamily:
                                                        theme.typography.heading_font,
                                                }}
                                            >
                                                {item.name}
                                            </h4>

                                            <p
                                                className="user-role"
                                                style={{
                                                    margin: 0,
                                                    fontSize: "0.8rem",
                                                    color: theme.colors.menu_text,
                                                }}
                                            >
                                                {item.role}
                                            </p>
                                        </div>
                                    </div>

                                    {/* QUOTE */}
                                    <span
                                        className="comma-text"
                                        style={{
                                            fontSize: "60px",
                                            opacity: 0.2,
                                            color: theme.colors.high_light,
                                            fontFamily: "serif",
                                        }}
                                    >
                                        ❝
                                    </span>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default ReviewSection;